import { ActionType } from 'typesafe-actions';
import * as prefillActions from './actions';
import { ActionCenterPrefill } from './action-center-prefill';
import { CLEAR_ACTION_CENTER_PREFILL, SET_ACTION_CENTER_PREFILL } from './constants';

export type ActionCenterPrefillAction = ActionType<typeof prefillActions>;

export default function actionCenterPrefillReducer(
  state: ActionCenterPrefill | null = null,
  action: ActionCenterPrefillAction,
): ActionCenterPrefill | null {
  switch (action.type) {
    case SET_ACTION_CENTER_PREFILL:
      return action.payload;
    case CLEAR_ACTION_CENTER_PREFILL:
      return null;
    default:
      return state;
  }
}
